import { useSelector } from "react-redux";
import { memo } from "react";
import { selectAdvancedTranslation } from "../../Linear/redux/selectors";
import { Translation } from "../../../common/Translation";

interface Props {
  translationKey: string;
}

// @ts-ignore
export const LinearTranslation = memo(({ translationKey }: Props) => {
  const translation = useSelector(selectAdvancedTranslation(translationKey));

  if (!translation) {
    return null;
  }

  return <Translation {...translation} />;
});
